import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { useHardwareSnapshot } from "../../lib/hardwareStore";
import { PrinterSettings } from "./PrinterSettings";
import { ReceiptSettings } from "./ReceiptSettings";

type Sub = "printer" | "receipt";

/** Hardware & receipts: the printer connection (Electron only), print quality, the A4 printer, and the receipt language / layout builder with its live preview. */
export function HardwarePanel() {
  const { t } = useTranslation();
  const { isManager } = useAuth();
  const hw = useHardwareSnapshot();
  const [sub, setSub] = useState<Sub>(hw.native ? "printer" : "receipt");
  const tabs: Sub[] = hw.native ? ["printer", "receipt"] : ["receipt"];
  return (
    <div className="space-y-5">
      <div className="card flex items-center gap-3.5 p-5">
        <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-gradient-to-tr from-cosmic-purple to-solar-orange text-2xl shadow-cosmic" aria-hidden>🖨️</div>
        <div>
          <h1 className="text-xl font-black tracking-tight">{t("hw.title")}</h1>
          <p className="text-xs font-medium text-gray-500">{t("hw.subtitle")}</p>
        </div>
      </div>
      <div className="flex gap-1.5" role="tablist" aria-label={t("hw.title")}>
        {tabs.map((x) => (
          <button key={x} role="tab" type="button" data-tab={x} aria-selected={sub === x} onClick={() => setSub(x)} className={`rounded-xl px-4 py-2 text-xs font-black transition ${sub === x ? "bg-cosmic-purple text-white shadow-cosmic" : "bg-white text-gray-600 hover:bg-purple-50"}`}>{t(`hw.tabs.${x}`)}</button>
        ))}
      </div>
      {sub === "printer" && hw.native && <PrinterSettings canEdit={isManager} />}
      {sub === "receipt" && <ReceiptSettings canEdit={isManager} />}
    </div>
  );
}
